import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { QuickReplyState } from '../../types'

export const fetchRepliesByCompanyAction = createAsyncAction(
  '@chat/FETCH_REPLIES_BY_COMPANY_REQUEST',
  '@chat/FETCH_REPLIES_BY_COMPANY_SUCCESS',
  '@chat/FETCH_REPLIES_BY_COMPANY_FAILURE'
)<Request, Success, Failure>()

const request = (state: QuickReplyState): QuickReplyState => ({
  ...state,
  isLoadingFetchRepliesByCompany: true
})

const success = (
  state: QuickReplyState,
  action: ActionType<typeof fetchRepliesByCompanyAction.success>
): QuickReplyState => {
  return {
    ...state,
    replies: action.payload.replies,
    isLoadingFetchRepliesByCompany: false,
    isSuccessOnFetchRepliesByCompany: true
  }
}

const failure = (state: QuickReplyState): QuickReplyState => ({
  ...state,
  isLoadingFetchRepliesByCompany: false,
  isErrorOnFetchRepliesByCompany: true
})

export const fetchRepliesByCompanyHandle = { asyncAction: fetchRepliesByCompanyAction, request, success, failure }
